import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../../../constants/table.cnst';
import { DeleteComponent } from '../../../../modules/shared/components/delete/delete.component';
import { AppStateService } from '../../../../services/app-state.service';
import { CommonService } from '../../../../services/common.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})

export class UsersListComponent implements OnInit {
  @Input() tableConfig: any = {};
  @Input() tableData: any = [];
  @Input() isCustomer: any = false;

  dataTypes = UM_TABLE_CNST.CLICKABLE_DATA_TYPE;
  opts = USER_MGMT_CNST.OPTIONS;
  showUserId : boolean = false;

  constructor(
    private modal: MatDialog,
    private appStateSrv: AppStateService,
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit() {
  }

  handleOptionClick(rowData: any) {   
    let data = this.tableData.find((d: any)=> d.emailId === rowData.data[1]['values'][0]);
    console.log(data);
    
    let e = {
      val : rowData['val'],
      data : data
    }

    if(rowData['val'] == USER_MGMT_CNST.OPTIONS.DELETE) {
      const modalRef = this.modal.open(DeleteComponent, USER_MGMT_CNST.DELETE_POPUP_OPTIONS);
      let postData = {
        userId: data.userId
      }
      modalRef.afterClosed().subscribe((result: any) => {
        if (result === true) {
          this.setOperationType({
            operation: USER_MGMT_CNST.OPERATION_TYPES.USER.DELETE_USER,
            postData
          });
        }
      }, (reason: any) => {
      });
    }else {
      this.router.navigate(['um','users','config'], {
        queryParams: {
          operation: e.val.toLowerCase(),
          userId: data.userId,
          config: 'info',
          applicationName: data.applicationDetails.applicationName,
          roleName: data.applicationDetails.roleName,
          title:e.val.toLowerCase()
        }
      })
      // this.commonService.handleOptionClick(e, !this.isCustomer? USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST : USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST);
    }
  }

  setOperationType(value : any) {
    this.appStateSrv.operationRef.next(value);
  }

  handleRowClick(rowdata: any, index: any) {

  }
}
